<template>
  <v-tooltip :open-on-click="touch" :open-on-hover="!touch" top>
    <template v-slot:activator="{ on, attrs }">
      <slot v-bind:on="on" v-bind:attrs="attrs" name="activator"> </slot>
    </template>
    <slot></slot>
  </v-tooltip>
</template>

<script>
export default {
  name: "MobileTooltip",
  data: () => ({
    touch: false
  }),
  beforeMount() {
    this.touch = matchMedia("(hover: none), (pointer: coarse)").matches;
  }
};
</script>
